import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import { createPinia } from 'pinia';
import { worker } from '@/mocks/browser';
import { commandKey, altKey } from '@/common/utils';
import App from './App.vue';
import router from './common/router';
import { i18n } from './common/plugins';
import axios from './common/plugins/axios';
import { Quasar, QuasarOptions } from './common/plugins/quasar';
import { sentry } from './common/plugins/sentry';

const app = createApp(App);

sentry(app, router);

// To start mock server
if (process.env.VUE_APP_MOCK_API === 'true') {
  worker.start({ onUnhandledRequest: 'bypass' });
}

app.provide('$commandKey', commandKey());
app.provide('$altKey', altKey());
app.provide('$preloadedVideos', []);

app.use(createHead());
app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(axios);
app.use(Quasar, QuasarOptions);
app.mount('#app');
